import React from "react";
import { ThinTextField, ThinTextAreaField } from "../../common/GeneralComponent";

const CommunityFeedback = ({ data }) => {
  if (!data) {
    return (
      <div className="text-center py-8 text-gray-500">No data available</div>
    );
  }

  const communitySatisfaction = data.community_express_satisfaction || "N/A";
  const complaintsReported = data.complaints_or_reported_issues || "N/A";
  const complaintsDetails = data.complaints_or_reported_issues_specify || "N/A";
  const suggestions = data.suggestion_from_community || "N/A";
  const monitorObservations = data.monitors_key_observations || "N/A";

  return (
    <div className="bg-white rounded p-4">
      <form className="w-full">
        {/* First Row - Satisfaction, Complaints, Empty */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Did the community express satisfaction with the feature?"
            value={communitySatisfaction}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Are there any complaints or reported issues?"
            value={complaintsReported}
            disabled
          />
          <div className="w-full"></div>
        </div>

        {/* Second Row - Key Issues (Full Width) - Only show if Yes */}
        {complaintsReported === "Yes" && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div className="w-full md:col-span-3">
              <ThinTextAreaField
                isRequired={false}
                label="If yes, what are the key issues reported?"
                value={complaintsDetails}
                disabled
              />
            </div>
          </div>
        )}

        {/* Third Row - Suggestions (Full Width) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="w-full md:col-span-3">
            <ThinTextAreaField
              isRequired={false}
              label="Suggestions from the community or focal persons"
              value={suggestions}
              disabled
            />
          </div>
        </div>

        {/* Fourth Row - Monitor's Observations (Full Width) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="w-full md:col-span-3">
            <ThinTextAreaField
              isRequired={false}
              label="Monitor's Key Observations"
              value={monitorObservations}
              disabled
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CommunityFeedback;